///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/components/editors/date/bindingContinuation"/>
import * as $ from "jquery";
import desktop = require("Core/Medius.Core.Web/Scripts/Medius/components/editors/date/desktop");
import originalContinuation = require("Core/Medius.Core.Web/Scripts/Medius/components/editors/bindingContinuation");

export = function(model:any, params:any, element:any, ...args:any[]) {
    args = [model, params, element, ...args];
    originalContinuation.apply(this, args);
    return desktop.call(this, model, element, $(element).find("input"));
};